import { toLocaleNumber, useTranslation } from "@chr/online-shared-ui-localizations";
import { Container } from "../../common/apis/dtos";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { ContainerDetailsInfo } from "./ContainerDetailsInfo";
import '../../common/utilities/Section.scss';

export interface ContainerDetailsSummaryProps {
  sequenceNumber: number;
  totalContainerCount: number;
  containerInfo: Container;
  isMobileScreen: boolean;
}

export const ContainerDetailsSummary = ({ sequenceNumber, totalContainerCount, containerInfo, isMobileScreen }: ContainerDetailsSummaryProps) => {
  const translate = useTranslation();
  const priority = containerInfo.priority ? "Yes" : "No";

  const container = () => {
    return (
      <Grid
        container
        spacing={2}
        className="container-summary-section"
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
      >
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('Container Type')}
            information={containerInfo.containerType}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('Seal Number')}
            information={containerInfo.sealNumber}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('Priority')}
            information={priority}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('Number of Commodities')}
            information={containerInfo.numberOfCommodities}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('Total Weight')}
            information={containerInfo.totalWeight?.standard ? containerInfo.totalWeight?.standard.toFixed(2) + ' lbs' : '-'}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('Volume')}
            information={containerInfo.volume ? (containerInfo.volume.standard.toLocaleString() + ' ft3') : '-'}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('Total Outer Pack Quantity')}
            information={containerInfo.outerPackQuantity ? containerInfo.outerPackQuantity : '-'}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        <Grid item xs={isMobileScreen ? 12 : 3}>
          <ContainerDetailsInfo
            title={translate('UoM')}
            information={containerInfo.uom}
            isMobileScreen={isMobileScreen}
          />
        </Grid>
        {isMobileScreen && (
          <Grid item xs={12}>
            <Typography className="container-count-mobile">
            {`${toLocaleNumber(sequenceNumber)} ${translate('of')} ${toLocaleNumber(totalContainerCount)}`}
            </Typography>
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <div data-testid="container-details-summary" className="section">
      <Stack
        direction="row"
        className="section-heading"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Box>{`Container ${containerInfo.containerNumber}`}</Box>
        {!isMobileScreen && (
        <Box className="container-count">
          {`${toLocaleNumber(sequenceNumber)} ${translate('of')} ${toLocaleNumber(totalContainerCount)}`}
        </Box>)}
      </Stack>
      <div className={isMobileScreen ? 'section-body-mobile' : 'section-body'}>
        {container()}
      </div>
    </div>
  );
};